module.exports = __webpack_public_path__ + "img/home1E.423afe58.png";